import React, {useState, useContext, useEffect} from "react";
import {makeStyles} from "@mui/styles"
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import {LoadingContext} from "@hoc/loading";
import {ErrorMessageContext} from "@hoc/errorMessage";
import {renderForm, updateInfo} from "@components/Form/renderForm";
import {add} from '@api/db';
import {validation} from "@services/validation";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';
import Typography from "@mui/material/Typography";
import {red} from '@mui/material/colors';
import {styled} from '@mui/material/styles';
import {Activate} from '@components/Activate';
import 'react-phone-number-input/style.css'


const ColorButton = styled(Button)(({theme}) => ({
    fontSize: 32,
    backgroundColor: red[500],
    '&:hover': {
        backgroundColor: red[700],
    },
}));

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    pagination: {
        textAlign: 'center',
    },
    paginationButton: {
        margin: '5px',
    },
    submitBlock: {
        textAlign: 'center',
    },
    register: {
        justifyContent: 'center',
        minHeight: '200px',
    }
});

export const SignUpForm = () => {
        const classes = useStyles();
        const {loading, setLoading} = useContext(LoadingContext);
        const {errorMessage, setErrorMessage} = useContext(ErrorMessageContext);
        const [register, setRegister] = useState(false);
        const [currentTab, setCurrentTab] = useState(0);
        const [validatePagination, setValidatePagination] = useState(true);
        const [form, setForm] = useState({});
        const [code, setCode] = useState(null);

        const onCallback = (e) => {
            updateOnCallback(e, columnData);
        }

        const updateOnCallback = (e, data) => {
            data.forEach((column) => {
                column.data.forEach((column) => {
                    if (column.name === e.target.name) {
                        let value = e.target.value;
                        if (column.type === 'select') {
                            if (!column.value.includes(value)) {
                                column.value.push(value);
                                value = column.value;
                            }
                        }
                        if (column.type === 'checkbox') {
                            if (!column.value.includes(value)) {
                                column.value.push(value);
                                value = column.value;
                            } else {
                                value = column.value.filter((list) => list !== value);
                            }
                        }
                        column.value = value;
                        column.error = '';
                    }
                })
                column.setFunc([...column.data]);
            })
        }

        const identificationData = [{
            name: 'identification',
            headerName: 'Please confirm whether you are',
            value: '',
            inputProps: {required: true},
            items: [
                {label: 'A freelance photographer', value: 'A freelance photographer'},
                {label: 'A company providing Photography Services', value: 'A company providing Photography Services'},
                {label: 'None of the above', value: 'None of the above'},
            ],
            type: 'radio',
            onCallback: onCallback,
            handleChange: (data) => {
                columnsIdentification.forEach((column) => {
                    if (column.name === 'number_of_photographer') {
                        column.classList = data.target.value == 'A company providing Photography Services' ? '' : 'hidden';
                    }
                })
                setColumnsIdentification([...columnsIdentification]);
                onCallback(data);
            },
        }, {
            name: 'number_of_photographer',
            headerName: 'Number of photographer',
            type: 'string',
            value: '',
            classList: 'hidden',
            onCallback: onCallback,
        }, {
            name: 'real_estate_photography',
            headerName: 'Do you do real estate Photography?',
            inputProps: {required: true},
            value: '',
            items: [
                {label: 'yes', value: 'yes'},
                {label: 'no', value: 'no'},
            ],
            type: 'radio',
            onCallback: onCallback,
            handleChange: onCallback,
        }, {
            name: 'experience_commercial_properties',
            headerName: 'Do you have any photography experience with commercial properties?',
            inputProps: {required: true},
            value: '',
            items: [
                {label: 'yes', value: 'yes'},
                {label: 'no', value: 'no'},
            ],
            type: 'radio',
            onCallback: onCallback,
            handleChange: onCallback,
        }];

        const contactInformationData = [{
            name: 'first_name',
            headerName: 'First name',
            inputProps: {required: true},
            value: '',
            type: 'string',
            onCallback: onCallback,
        }, {
            name: 'last_name',
            headerName: 'Last name',
            type: 'string',
            inputProps: {required: true},
            value: '',
            onCallback: onCallback,
        }, {
            name: 'email',
            headerName: 'Email',
            type: 'string',
            value: '',
            inputProps: {required: true, type: 'email'},
            onCallback: onCallback,
        }, {
            name: 'phone',
            headerName: 'Phone',
            inputProps: {required: true},
            type: 'phone',
            value: '',
            onCallback: onCallback,
        }, {
            name: 'address',
            headerName: 'Address',
            inputProps: {required: true},
            type: 'string',
            value: '',
            onCallback: onCallback,
        }, {
            name: 'city',
            headerName: 'City',
            inputProps: {required: true},
            type: 'string',
            value: '',
            onCallback: onCallback,
        }, {
            name: 'state',
            headerName: 'State/Region/Province',
            inputProps: {required: true},
            type: 'string',
            value: '',
            onCallback: onCallback,
        }, {
            name: 'zip_code',
            headerName: 'Postal / Zip Code',
            value: '',
            inputProps: {required: true},
            type: 'string',
            onCallback: onCallback,
        }, {
            name: 'country',
            headerName: 'Country',
            value: '',
            type: 'string',
            onCallback: onCallback,
        }
        ];

        const servicesData = [
            {
                name: 'have_360_camera',
                headerName: 'Do you currently own 360 equipment',
                value: '',
                inputProps: {required: true},
                items: [
                    {label: 'yes', value: 'yes'},
                    {label: 'no', value: 'no'},
                ],
                type: 'radio',
                onCallback: onCallback,
                handleChange: (data) => {
                    columnsServices.forEach((column) => {
                        if (column.name === 'what_360_camera') {
                            column.classList = data.target.value == 'yes' ? '' : 'hidden';
                        }
                    })
                    setColumnsServices([...columnsServices]);
                    onCallback(data)
                },
            }, {
                name: 'what_360_camera',
                headerName: 'What 360 camera equipment do you have ?',
                inputProps: {required: true},
                value: [],
                multiple: true,
                classList: 'hidden',
                defaultValue: '',
                renderValue: (selected) => (
                    <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                        {selected.map((value) => (
                            <Chip key={value} label={value}/>
                        ))}
                    </Box>
                ),
                items: [
                    'Ricoh Theta V',
                    'Ricoh Theta Z1',
                    'Insta One X',
                    'DSLR camera with wide angle Lens',
                    'Matterport Pro 2',
                    'Other',
                    'None',
                ],
                type: 'enum',
                onCallback: (data) => {
                    columnsServices.forEach((column) => {
                        if (['own_camera'].includes(column.name)) {
                            column.classList = data.target.value.includes('Other') ? '' : 'hidden';
                        }
                    })
                    setColumnsServices([...columnsServices]);
                    onCallback(data);
                },
            }, {
                name: 'own_camera',
                classList: 'hidden',
                headerName: 'Add your own camera.',
                inputProps: {required: true},
                value: '',
                size: 'half-screen',
                type: 'string',
                onCallback: onCallback,
            }, {
                name: 'areas',
                headerName: 'What locations do you work in?',
                inputProps: {required: true},
                value: '',
                size: 'half-screen',
                type: 'string',
                onCallback: onCallback,
            }, {
                name: 'travel',
                inputProps: {required: true},
                headerName: 'How far can you travel outside of these areas?',
                value: 0,
                type: 'slider',
                onCallback: onCallback,
            }, {
                name: 'services',
                headerName: 'What services do you offer',
                inputProps: {required: true},
                value: [],
                items: [
                    'Standard 2D photography',
                    'HDR  Pro 2D photography',
                    '360 photography',
                    'Drone photography',
                    'Drone Video',
                    'videography services',
                    'Professional floor plan with measurements',
                ],
                type: 'checkbox',
                onCallback: onCallback,
                handleChange: onCallback,
            },
            {
                name: 'software_provider',
                headerName: 'Do you currently use a 360 tour provider?',
                value: '',
                inputProps: {required: true},
                items: [
                    {label: 'yes', value: 'yes'},
                    {label: 'no', value: 'no'},
                ],
                type: 'radio',
                onCallback: onCallback,
                handleChange: (data) => {
                    columnsServices.forEach((column) => {
                        if (['software_solution'].includes(column.name)) {
                            column.classList = data.target.value == 'yes' ? '' : 'hidden';
                        }
                    })
                    setColumnsServices([...columnsServices]);
                    onCallback(data);
                },
            }, {
                name: 'software_solution',
                headerName: 'Which tour platform do you use?',
                classList: 'hidden',
                inputProps: {required: true},
                value: '',
                size: 'half-screen',
                type: 'string',
                onCallback: onCallback,
            }, {
                name: 'other_charges',
                headerName: 'What are your hourly charges',
                inputProps: {required: true},
                value: '',
                size: 'half-screen',
                type: 'string',
                onCallback: onCallback,
            }, {
                name: 'insurance',
                headerName: 'Do you have insurance?',
                value: '',
                inputProps: {required: true},
                items: [
                    {label: 'yes', value: 'yes'},
                    {label: 'no', value: 'no'},
                ],
                type: 'radio',
                handleChange: (data) => {
                    servicesData.forEach((column) => {
                        if (['type_insurance', 'amount_insured', 'expiry_date'].includes(column.name)) {
                            column.classList = data.target.value == 'yes' ? '' : 'hidden';
                        }
                    })
                    setColumnsPortofolioData([...columnsPortofolioData]);
                    onCallback(data);
                },
                onCallback: onCallback,
            }, {
                name: 'type_insurance',
                headerName: 'Type of insurance',
                inputProps: {required: true},
                classList: 'hidden',
                value: '',
                type: 'string',
                onCallback: onCallback,
            }, {
                name: 'amount_insured',
                headerName: 'Amount insured',
                inputProps: {required: true},
                classList: 'hidden',
                value: '',
                type: 'string',
                onCallback: onCallback,
            }, {
                name: 'expiry_date',
                headerName: 'Expiry date',
                inputProps: {required: true},
                classList: 'hidden',
                value: '',
                type: 'date',
                onCallback: onCallback,
            },
        ]

        const portofolioData = [
            {
                name: 'website',
                headerName: 'Please provide a link to examples of your work or website',
                value: '',
                type: 'string',
                onCallback: onCallback,
            },
        ]

        const [columnsIdentification, setColumnsIdentification] = useState(identificationData);
        const [columnsContactInformation, setColumnsContactInformation] = useState(contactInformationData);
        const [columnsServices, setColumnsServices] = useState(servicesData);
        const [columnsPortofolioData, setColumnsPortofolioData] = useState(portofolioData);
        const columnData = [
            {data: columnsIdentification, setFunc: setColumnsIdentification},
            {data: columnsContactInformation, setFunc: setColumnsContactInformation},
            {data: columnsServices, setFunc: setColumnsServices},
            {data: columnsPortofolioData, setFunc: setColumnsPortofolioData},
        ]

        const handleSubmit = async (event) => {
            event.preventDefault();

            if (!validateColumn(currentTab + 1)) return;

            setLoading(true);
            setErrorMessage(null);

            try {
                const data = new FormData(event.target);
                let obj = updateInfo([...columnsIdentification, ...columnsContactInformation, ...columnsServices, ...columnsPortofolioData], data);
                setForm(obj)
                obj.type = 'sign_up_form';
                obj.date = new Date().toLocaleDateString()
                const docRef = await add(obj);
                setLoading(false);

                if (docRef.data.error) {
                    return alert(docRef.data.error)
                }
                if (docRef.data.code) {
                    setCode(docRef.data.code);
                }
                setRegister(true);
            } catch (e) {
                validateData(e, columnData);
                setErrorMessage(e);
                setLoading(false);
            }
        }

        const validateData = (e, data) => {
            data.forEach((column) => {
                validation(e, column.data, (columnUpdate) => {
                    return column.setFunc([...columnUpdate]);
                })
            })
        }

        const columnsEl = [
            {
                label: 'Identification',
                data: columnsIdentification,
            }, {
                label: 'Contact information',
                data: columnsContactInformation,
            },
            {
                label: 'Services',
                data: columnsServices,
            },
            {
                label: 'Portofolio',
                data: columnsPortofolioData,
            }]

        const validateEmail = (email) => {
            return String(email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        };

        const validateColumn = (ind) => {
            const currentTab = columnData[ind - 1];
            let validatePaginationData = true;
            currentTab.data.forEach((val) => {

                if (!val?.classList?.match('hidden') && val?.inputProps?.type === 'email' && val.value && validateEmail(val.value) === null) {
                    validatePaginationData = false;
                    val.error = 'validate email';
                }

                if (!val?.classList?.match('hidden') && val?.inputProps?.required &&
                    (!val.value || (typeof val.value === 'object' && !val.value.length && !(val.value instanceof Date)) || (typeof val.value === 'number' && !val.value))) {
                    validatePaginationData = false;
                    val.error = 'is required field';
                }
            })

            columnData[ind - 1].setFunc([...currentTab.data]);

            return validatePaginationData;
        }

        const next = (ind) => {
            let validatePaginationData = validateColumn(ind);

            if (validatePaginationData) {
                setValidatePagination(validatePaginationData);
                setCurrentTab(ind);
                setValidatePagination(true);

                return;
            }

        }

        const prev = (ind) => {
            setCurrentTab(ind);
        }

        useEffect(() => {
            if (window?.parent?.document?.querySelector(".professional_photography_network_booking iframe")) {
                window.parent.document.querySelector(".professional_photography_network_booking iframe").scrollIntoView();
            }
        }, [currentTab])

        const showPricing = async () => {
            const url = 'https://www.eyespy360.com/en-gb/service/professional_photography_network.html#pricing'
            if(window.parent){
                window.parent.location.href = url;
                return window.parent.location.reload(true);
            }

            window.location.href = url;
            window.location.reload(true)
        }

        if(register){
            showPricing()
        }

        return (<>
                {register ? <Activate code={code} form={form}/> : <></>}
                <Container maxWidth={'md'}
                           component="form"
                           className={register ? 'hidden' : ''}
                           noValidate
                           onSubmit={handleSubmit}>
                    {columnsEl.map((column, ind) => (
                        <Grid xs={12} key={ind} item className={currentTab === ind ? '' : 'hidden'}
                              container
                              justifyContent="start"
                              alignItems="center"
                              spacing={3}>
                            <Grid xs={12} item><Typography variant="h4" gutterBottom>{column.label}</Typography>
                                <hr/>
                            </Grid>
                            {
                                column.data.map((data, key) => (
                                    renderForm(data, key)
                                ))
                            }
                            <Grid className={classes.pagination} key={ind + 'pagination'} xs={12} item>
                                <Button variant="contained"
                                        className={currentTab === 0 ? 'hidden' : classes.paginationButton}
                                        onClick={() => prev(ind > 0 ? ind - 1 : 0)}>prev</Button>
                                <Button variant="contained"
                                        className={currentTab === columnsEl.length - 1 ? 'hidden' : classes.paginationButton}
                                        onClick={() => next(ind > columnsEl.length ? columnsEl.length : ind + 1)}>next</Button>
                            </Grid>

                            <Grid item
                                  style={{textAling: 'left'}}
                                  xs={12}
                            >
                                <Typography variant="caption">*Mandatory</Typography>
                            </Grid>
                            <Grid item
                                  className={currentTab == columnsEl.length - 1 ? classes.submitBlock : 'hidden'}
                                  xs={12}
                            >
                                <ColorButton
                                    type="submit"
                                    variant="contained"
                                >
                                    submit
                                </ColorButton>
                            </Grid>
                        </Grid>
                    ))}
                </Container>

            </>
        );
    }
;